<script>
	import { state } from './store/stores.js';
	import CardGame from './components/CardGame.svelte';

	const preload = () => {
		const frontImageIds = $state.allIds.map(id =>$state.byIds[id].frontImgPath);
		const backImageIds = $state.allIds.map(id =>$state.byIds[id].backImgPath);

		const imageSources = [
			...frontImageIds,
			...backImageIds,
			'images/extra_elements/tarto.png',
			'images/extra_elements/hamutarto.png',
			'images/extra_elements/borito.png',
			'images/extra_elements/background_desk.png',
			'images/extra_elements/play_button.png',
			'images/extra_elements/pause_button.png',
			'images/extra_elements/nagymama.png',
		]

		const promises = imageSources.map(src => 
			new Promise(resolve => {
				let img = new Image();
				img.onload = resolve;
				img.src = src;
			})
		);
		
		return Promise.all(promises)
			.then(() => console.log('images loaded'));
	}
</script>


{#await preload() then _}
	<span class="game">
		<CardGame/>
	</span>
{/await}

<div class="loading-container">Betöltés...</div>

<div class="mobile-message">A Zikaron csak széles desktop képernyôn játszható</div>

<style>
	:global(html) {
		height: 100%;
		font-family: Emberly;
		line-height: 28px;
		font-size: 23px;
		letter-spacing: 1px;
	}
	:global(body) {
		padding: 0px;
		margin: 0px;
		overflow: hidden;
		user-select: none;
		height: 100%;
	}
	:global(img) {
        user-drag: none; 
        user-select: none;
        -moz-user-select: none;
        -webkit-user-drag: none;
        -webkit-user-select: none;
        -ms-user-select: none;
	}
	.loading-container, .mobile-message {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 10px;
	}

	.mobile-message {
		text-align: center;
		display: none;
	}

	@font-face {
		font-family: 'Emberly';
		src: url("../fonts/Emberly-Regular.woff") format("woff");
		font-style: normal;
	}

	@media(max-width: 1000px) {
		.loading-container, .game {
			display: none
		}

		.mobile-message {
			display: flex;
		}
	}
</style>